function some(_) {
  if (void 0 === _) {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: 0
    };
  } else if (null !== _ && void 0 !== _.BS_PRIVATE_NESTED_SOME_NONE) {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: _.BS_PRIVATE_NESTED_SOME_NONE + 1 | 0
    };
  } else {
    return _;
  }
}

function nullable_to_opt(_) {
  if (null == _) {
    return;
  } else {
    return some(_);
  }
}

function undefined_to_opt(_) {
  if (void 0 === _) {
    return;
  } else {
    return some(_);
  }
}

function null_to_opt(_) {
  if (null === _) {
    return;
  } else {
    return some(_);
  }
}

function valFromOption(_) {
  if (null === _ || void 0 === _.BS_PRIVATE_NESTED_SOME_NONE) {
    return _;
  }
  var n = _.BS_PRIVATE_NESTED_SOME_NONE;
  if (0 === n) {
    return;
  } else {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: n - 1 | 0
    };
  }
}

export { null_to_opt as a, nullable_to_opt as n, some as s, undefined_to_opt as u, valFromOption as v };
